import React from "react";
import List from "@mui/material/List";

import useActiveContexts from "../useActiveContexts";
import ContextItem from "./ContextItem";

function ContextList() {
  const { libraryContexts } = useActiveContexts();

  return (
    <List component="div" disablePadding>
      {libraryContexts.map((context) => (
        <ContextItem key={context.id} context={context} />
      ))}
    </List>
  );
}

export default ContextList;
